/**
 * AdMockupContainer Component
 *
 * Container wrapper for all ad mockups
 * Provides consistent styling, platform badge, and helper text
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/Badge';
import { getPlatformIcon, getPlatformName } from '../utils/platformConfig';
import { AdMockupContainerProps } from '../types/base.types';

export const AdMockupContainer: React.FC<AdMockupContainerProps> = ({
  platform,
  label,
  className,
  children,
  showPlatformBadge = true,
  showHelperText = true,
}) => {
  return (
    <div className={cn(
      'ad-mockup-wrapper',
      'bg-gray-50 dark:bg-background-dark/50',
      'rounded-lg p-4 border border-gray-200 dark:border-border-dark',
      className
    )}>
      {/* Platform Badge */}
      {showPlatformBadge && (
        <div className="mb-3 flex items-center justify-between">
          <Badge variant="info" size="sm" className="gap-1.5">
            <span>{getPlatformIcon(platform)}</span>
            <span>Preview: {getPlatformName(platform)}</span>
          </Badge>
          {label && (
            <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">
              {label}
            </span>
          )}
        </div>
      )}

      {/* Mockup Content */}
      <div className="ad-mockup-content">
        {children}
      </div>

      {/* Helper Text */}
      {showHelperText && (
        <p className="mt-3 text-xs text-center text-gray-500 dark:text-gray-400 italic">
          This is a preview of how your ad will appear to users
        </p>
      )}
    </div>
  );
};

export default AdMockupContainer;
